import {
  Box,
  Grid,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Select,
  Checkbox,
  TextField,
  Autocomplete,
  FormControl,
  InputLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { format } from "date-fns";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";

import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate, useSearchParams } from "react-router-dom";
import StatusAlert from "../../../StatusAlertList/StatusAlert";

import { getUserInfo } from "../../../Data/UserData";

import { driverLeaveApis, jobCreatedApis, clientApis } from "../../../Data/axios";
import config from "../../../Data/AuthUser";
import ReactQuill from "react-quill";
import HeaderVacanciesCreated from "./HeaderVacanciesCreated";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Component to handle image with fallback
const ClientAvatar = ({ username, userId, image, getInitials }) => {
  const [imageError, setImageError] = React.useState(false);
  const imageUrl = image ? `${config.apiImageUrl}${image}` : null;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {image && !imageError ? (
        <img
          src={imageUrl}
          alt="client"
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            objectFit: "cover",
            marginRight: "10px",
          }}
          onError={() => setImageError(true)}
        />
      ) : (
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            backgroundColor: "#1d82f5",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "10px",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          {getInitials(username)}
        </div>
      )}
      <div>
        <div style={{ fontWeight: "bold" }}>{username || ""}</div>
        <div style={{ color: "gray", fontSize: "12px" }}>{userId || ""}</div>
      </div>
    </div>
  );
};

function VacanciesCreated() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Read URL parameters immediately on component mount
  const pageFromUrl = searchParams.get('page');
  const limitFromUrl = searchParams.get('limit');

  console.log("🔍 Component Initialization - Full URL:", window.location.href);
  console.log("🔍 Component Initialization - Search params:", window.location.search);
  console.log("🔍 Component Initialization - URL Parameters:", { pageFromUrl, limitFromUrl });

  // Initialize state with URL parameters or defaults
  const [radioButton, setRadioButton] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [descriptionRemark, setDescriptionRemark] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openRemark, setOpenRemark] = React.useState(false);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  const [name, setName] = React.useState("");

  const [price, setPrice] = React.useState("");
  const [discount, setDiscount] = React.useState("");
  const [call, setCall] = React.useState("");
  const [color, setColor] = useState("#ff0000");
  const [post, setPost] = React.useState("");

  const [validity, setValidity] = React.useState("");

  const [userType, setUserType] = useState("");
  const [visibility, setVisibility] = useState("");

  // Initialize pagination state with URL parameters or defaults using lazy initialization
  const [pageValue, setPageValue] = useState(() => {
    const page = pageFromUrl ? parseInt(pageFromUrl) : 1;
    console.log("📊 Initial pageValue set to:", page, "from URL:", pageFromUrl);
    return page;
  });
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const limit = limitFromUrl ? parseInt(limitFromUrl) : 5;
    console.log("📊 Initial rowsPerPage set to:", limit, "from URL:", limitFromUrl);
    return limit;
  });
  const [rowCountValue, setRowCountValue] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [articalData, setArticalData] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");
  const [selectedRadio, setSelectedRadio] = useState("Client");

  // Reactively update state when URL parameters change
  useEffect(() => {
    const currentPageFromUrl = searchParams.get('page');
    const currentLimitFromUrl = searchParams.get('limit');

    console.log("🔄 URL Parameter Change Detected:", { currentPageFromUrl, currentLimitFromUrl });

    if (currentPageFromUrl && currentPageFromUrl !== pageValue.toString()) {
      const newPage = parseInt(currentPageFromUrl);
      console.log("🔄 Updating pageValue from URL:", newPage);
      setPageValue(newPage);
    }

    if (currentLimitFromUrl && currentLimitFromUrl !== rowsPerPage.toString()) {
      const newLimit = parseInt(currentLimitFromUrl);
      console.log("🔄 Updating rowsPerPage from URL:", newLimit);
      setRowsPerPage(newLimit);
    }
  }, [searchParams]); // Re-run when URL parameters change

  // Add Jobs Modal State
  const [openAddJob, setOpenAddJob] = useState(false);
  const [addJobData, setAddJobData] = useState({
    client_id: "",
    start_location: "",
    end_location: "",
    salary: "",
    vehicle_id: "",
    salary_type: "",
    nature: "",
    lat: "",
    lng: "",
    disable_client: false,
  });
  const [clients, setClients] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  // Function to update URL with current pagination state
  const updateUrlWithPagination = (page, limit) => {
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);

    const newUrl = `?${params.toString()}`;
    console.log("🔄 Updating URL to:", newUrl);

    // Navigate to the same path with updated parameters
    navigate({ search: params.toString() }, { replace: true });
  };

  // Generate salary options from 0 to 100000 with 5000 difference
  const generateSalaryOptions = () => {
    const options = [];
    for (let i = 0; i <= 100000; i += 5000) {
      const next = i + 5000;
      if (i === 0) {
        options.push(`0 - ${next}`);
      } else if (next > 100000) {
        options.push(`${i}+`);
      } else {
        options.push(`${i} - ${next}`);
      }
    }
    return options;
  };

  const salaryOptions = generateSalaryOptions();

  // Job nature options for autocomplete
  const jobNatureOptions = [
    "Trip wise",
    "Contract",
    "Full time"
  ];
  const [filters, setFilters] = useState({
    timestamps: "",
    Status: "",
    search: "",
  });

  const [statusType, setStatusType] = useState([]);
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  useEffect(() => {
    if (selectedRadio === "App User") {
      setRadioButton(true);
    } else {
      setRadioButton(false);
    }
  }, [selectedRadio]);
  function formatDate(isoString) {
    const date = new Date(isoString);

    // Get the date components
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    // Get the time components
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  }

  const handleFileChange = (event) => {
    setUploadFile(event.target.files[0]);
  };

  const handleUpdateDetails = () => {
    setOpenRemark(true);
  };

  const [description, setDescription] = useState("");

  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPageValue(1); // Reset to first page when filters change
  };

  // Add Jobs Modal Functions
  const handleOpenAddJob = () => {
    setOpenAddJob(true);
    fetchClients();
    // Don't fetch vehicles initially - will fetch when client is selected
  };

  const handleCloseAddJob = () => {
    setOpenAddJob(false);
    setAddJobData({
      client_id: "",
      start_location: "",
      end_location: "",
      salary: "",
      vehicle_id: "",
      salary_type: "",
      nature: "",
      lat: "",
      lng: "",
      disable_client: false,
    });
    setVehicles([]); // Clear vehicles when closing the modal
  };

  const handleAddJobChange = (field, value) => {
    // Update the field value
    setAddJobData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // If start_location is being updated, trigger geocoding with debouncing
    if (field === "start_location") {
      // Clear previous timeout if exists
      if (geocodeTimeoutRef.current) {
        clearTimeout(geocodeTimeoutRef.current);
      }

      // Set new timeout for debouncing (500ms delay)
      if (value && value.trim() !== "") {
        setAddJobData((prev) => ({
          ...prev,
          lat: "",
          lng: "",
        })); // Clear coordinates while typing

        geocodeTimeoutRef.current = setTimeout(async () => {
          const coordinates = await geocodeLocation(value);
          setAddJobData((prev) => ({
            ...prev,
            lat: coordinates.lat,
            lng: coordinates.lng,
          }));
        }, 800); // 800ms delay to avoid too many API calls
      } else {
        // Clear coordinates if input is empty
        setAddJobData((prev) => ({
          ...prev,
          lat: "",
          lng: "",
        }));
      }
    }
  };

  // Ref for geocoding timeout
  const geocodeTimeoutRef = React.useRef(null);

  const fetchClients = async () => {
    try {
      // Fetch all clients with no limit to get all available clients
      const response = await clientApis.getAll(1, 1000);
      // Map the response to the expected format
      const clientsList = response?.data?.records?.map(client => ({
        id: client.user_id || client.id,
        username: client.username || client.name || `Client ${client.id}`,
      })) || [];
      setClients(clientsList);
    } catch (error) {
      console.error("Error fetching clients:", error);
      showAlert("Failed to fetch clients", "error");
    }
  };

  // Debug: Monitor vehicles state changes
  React.useEffect(() => {
    console.log("Vehicles state updated:", vehicles);
    console.log("Number of vehicles:", vehicles.length);
  }, [vehicles]);

  // Cleanup geocoding timeout on component unmount
  React.useEffect(() => {
    return () => {
      if (geocodeTimeoutRef.current) {
        clearTimeout(geocodeTimeoutRef.current);
      }
    };
  }, []);

  // Geocoding function to convert city name to lat/lng coordinates
  const geocodeLocation = async (locationName) => {
    if (!locationName || locationName.trim() === "") {
      return { lat: "", lng: "" };
    }

    try {
      // Using OpenStreetMap Nominatim API (free, no API key required)
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(locationName)}&limit=1`
      );

      if (!response.ok) {
        throw new Error("Geocoding request failed");
      }

      const data = await response.json();

      if (data && data.length > 0) {
        const { lat, lon } = data[0];
        console.log(`Geocoded "${locationName}" to: lat=${lat}, lng=${lon}`);
        return { lat: parseFloat(lat), lng: parseFloat(lon) };
      } else {
        console.warn(`No coordinates found for "${locationName}"`);
        return { lat: "", lng: "" };
      }
    } catch (error) {
      console.error("Error geocoding location:", error);
      return { lat: "", lng: "" };
    }
  };

  const fetchVehicles = async (clientId) => {
    try {
      // Use default client ID if none provided or if client selection is disabled
      const targetClientId = clientId || "RPTPLOWN1726939809";
      console.log("Fetching vehicles for client:", targetClientId);
      const response = await jobCreatedApis.getFleetOwnerVehicles(targetClientId);

      console.log("Vehicle API response:", response);

      // Handle different response structures
      let vehicleData = [];
      if (response?.data && Array.isArray(response.data)) {
        vehicleData = response.data;
      } else if (response && Array.isArray(response)) {
        vehicleData = response;
      } else if (response?.data?.data && Array.isArray(response.data.data)) {
        vehicleData = response.data.data;
      }

      console.log("Vehicle data array:", vehicleData);

      // Map the API response to the expected format
      const vehiclesList = vehicleData.map(vehicle => {
        const brand = vehicle.brand?.[0]?.brand || vehicle.vehicle_brand || "";
        const wheels = vehicle.models?.[0]?.wheels || "";
        const model = vehicle.models?.[0]?.model || vehicle.vehicle_model || "";
        const vehicleId = vehicle.vehicle_id || vehicle.id || "";

        return {
          id: vehicle.id || vehicle.vehicle_id,
          vehicle_id: vehicleId,
          brand: brand,
          wheels: wheels,
          model: model,
          name: `${vehicleId} / ${brand} / ${wheels} wheeler / ${model}`,
        };
      });

      console.log("Mapped vehicles list:", vehiclesList);
      setVehicles(vehiclesList);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      showAlert("Failed to fetch vehicles", "error");
    }
  };

  const handleSaveJob = async () => {
    // Validation
    if (!addJobData.disable_client && !addJobData.client_id) {
      showAlert("Please select a client", "warning");
      return;
    }
    if (!addJobData.start_location) {
      showAlert("Please enter start location", "warning");
      return;
    }
    if (!addJobData.end_location) {
      showAlert("Please enter end location", "warning");
      return;
    }
    if (!addJobData.nature) {
      showAlert("Please enter job nature", "warning");
      return;
    }
    if (!addJobData.salary) {
      showAlert("Please select or enter salary", "warning");
      return;
    }
    if (!addJobData.vehicle_id) {
      showAlert("Please select a vehicle", "warning");
      return;
    }

    try {
      // Get the selected vehicle details
      const selectedVehicle = vehicles.find(v => v.id === addJobData.vehicle_id);

      // Prepare API payload matching Laravel requirements
      const now = new Date();

      // Format timestamp as YYYY-MM-DD HH:MM:SS
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      const currentTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      const apiPayload = {
        StartLocation: addJobData.start_location,
        EndLocation: addJobData.end_location,
        vehicle_id: selectedVehicle?.vehicle_id || parseInt(addJobData.vehicle_id),
        Nature: addJobData.nature,
        Salary: addJobData.salary,
        time: currentTimestamp,
        fleet_owner_id: addJobData.disable_client ? "RPTPLOWN1726939809" : addJobData.client_id,
        Status: 1, // Default to active
        lat: addJobData.lat ? parseFloat(addJobData.lat) : null,
        lng: addJobData.lng ? parseFloat(addJobData.lng) : null
      };

      console.log("Sending API payload:", apiPayload);

      // Call the API to save the job
      const response = await jobCreatedApis.createJobWithNotifications(apiPayload);
      console.log("API response:", response);

      showAlert("Job added successfully", "success");
      handleCloseAddJob();
      getData(); // Refresh the table
    } catch (error) {
      console.error("Error saving job:", error);
      showAlert("Failed to add job", "error");
    }
  };

  const handleViewMore = async (value) => {
    // Find the full record from articalData where id matches value
    const fullRecord = articalData.find((item) => item.id === value);
    console.log("Full record found:", fullRecord);

    if (fullRecord) {
      // Pass page and limit as URL parameters and actual row data in state
      navigate(`/jobs/created/${fullRecord.id}?page=${pageValue}&limit=${rowsPerPage}`, { state: fullRecord });
    } else {
      showAlert("Record not found", "error");
    }
  };

  const [openMenuId, setOpenMenuId] = useState(null);
  const userInfoString = localStorage.getItem("user-info");
  // Parse the string into an object
  const userInfo = JSON.parse(userInfoString);

  // Helper function to get initials from username
  const getInitials = (name) => {
    if (!name) return "NA";
    const words = name.split(" ");
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };
  const handleAllData = () => {
    setOpen(false);
    setName("");
    setDescription("");
    setUploadFile("");
    setSelectedRadio("");
    setSelectCategory("");
  };

  const item = {
    membership: name,
    price: price,
    discount: discount,
    calls: call,
    jobspost: post,
    validity: validity,
    role: userType,
    color: color,
    access: visibility,
  };

  async function SaveData() {
    const formData = new FormData();
    // Append each item to the FormData object
    for (const key in item) {
      if (item[key] !== undefined && item[key] !== null) {
        formData.append(key, item[key]);
      }
    }

    // let result = await fetch(
    //   "https://rptpl.roadpilot.co.in/public/api/addMemberShip",
    //   {
    //     method: "POST",
    //     body: formData,
    //   }
    // );

    // if (!result.ok) {
    //   throw new Error(`HTTP error! status: ${result.status}`);
    // }

    // const response = await result.json();

    showAlert("Added successfully", "success");
    handleAllData();
    getData();
  }
  const itemDetails = {
    status: statusType,
    approved_by: getUserInfo(),
    approved_at: format(new Date(), "yyyy-MM-dd HH:mm:ss 'UTC'"),
    note: descriptionRemark,
  };
  async function SaveRemark() {
    const formData = new FormData();
    // Append each item to the FormData object
    for (const key in itemDetails) {
      if (itemDetails[key] !== undefined && itemDetails[key] !== null) {
        formData.append(key, itemDetails[key]);
      }
    }
    try {
      await driverLeaveApis.remarkById(openMenuId, formData);

      showAlert("Updated successfully", "success");

      handleCloseRemark();
      getData();
    } catch {
      showAlert("Failed to update", "warning");
    }
  }
  // ends Here

  // Table Starts Here

  useEffect(() => {
    console.log("🔄 useEffect triggered with:", { pageValue, rowsPerPage, filters });
    console.log("📊 About to call getData()...");
    getData();
  }, [rowsPerPage, pageValue, filters]);

  // Add stabilization to prevent table from overriding our controlled state
  const [tableKey, setTableKey] = useState(0);

  useEffect(() => {
    console.log("🔄 Table key updated due to state change:", { pageValue, rowsPerPage });
    setTableKey(prev => prev + 1);
  }, [pageValue, rowsPerPage]);

  async function getData() {
    try {
      console.log("🔍 getData called with:", { pageValue, rowsPerPage, filters });

      // Build query parameters based on filters
      const params = {};

      // Add filters to params if they have values
      if (filters.timestamps) {
        params.timestamps = filters.timestamps;
      }
      if (filters.Status) {
        params.Status = filters.Status;
      }
      if (filters.search) {
        // Search can match StartLocation, EndLocation, or fleet_owner_id
        // Send the search value to all searchable fields
        params.StartLocation = filters.search;
        params.EndLocation = filters.search;
        params.fleet_owner_id = filters.search;
      }

      console.log("📡 Final API call parameters:", {
        page: pageValue,
        limit: rowsPerPage,
        ...params
      });

      let results = await jobCreatedApis.getAll(pageValue, rowsPerPage, params);

      console.log("✅ Full API response:", results);
      console.log("✅ Response structure check:", {
        isObject: typeof results === 'object',
        hasData: !!results?.data,
        dataHasRecords: !!results?.data?.records,
        dataHasTotalPages: !!results?.data?.total_pages,
        dataHasTotalRecords: !!results?.data?.total_records,
      });

      // Handle both response structures: { data: { records: [...] } } and { records: [...] }
      let records = [];
      let totalPages = 0;
      let totalRecords = 0;
      let perPage = rowsPerPage;

      if (results?.data?.records && Array.isArray(results.data.records)) {
        records = results.data.records;
        totalPages = results.data.total_pages || 0;
        totalRecords = results.data.total_records || 0;
        perPage = results.data.per_page || rowsPerPage;
        console.log("✅ Using response.data.records structure");
      } else if (results?.records && Array.isArray(results.records)) {
        records = results.records;
        totalPages = results.total_pages || 0;
        totalRecords = results.total_records || 0;
        perPage = results.per_page || rowsPerPage;
        console.log("✅ Using response.records structure");
      } else if (Array.isArray(results)) {
        records = results;
        console.log("✅ Using direct array structure");
      } else {
        console.error("❌ Unknown response structure:", results);
        console.error("❌ Available keys:", results ? Object.keys(results) : 'null');
      }

      console.log("📊 Final extracted data:", {
        recordsLength: records.length,
        totalPages,
        totalRecords,
        perPage
      });

      // Only update rowsPerPage if it's different from what we already have
      if (perPage && perPage !== rowsPerPage) {
        console.log("🔄 Updating rowsPerPage from API:", perPage);
        setRowsPerPage(perPage);
      }

      setArticalData(records);
      setTotalPages(totalPages);
      setRowCountValue(totalRecords);
    } catch (error) {
      console.error("❌ Error fetching data:", error);
      console.error("❌ Error details:", error.response?.data);
      console.error("❌ Error status:", error.response?.status);
      showAlert("Failed to fetch data", "error");
      setArticalData([]);
      setTotalPages(0);
      setRowCountValue(0);
    }
  }
  const leaveStatus = (value) => {
    if (value === "1")
      return <span style={{ color: "green", fontSize: "15px" }}>Active</span>;
    return <span style={{ color: "red", fontSize: "15px" }}>Closed</span>;
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      name: "username",
      label: "Client's Name",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Client's Name
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          // Get the row index and access the original data directly
          const rowIndex = tableMeta.rowIndex;
          const rowData = articalData[rowIndex];

          if (!rowData) {
            return <div>Loading...</div>;
          }

          const username = rowData.username;
          const userId = rowData.user_id;
          const image = rowData.image;

          return <ClientAvatar username={username} userId={userId} image={image} getInitials={getInitials} />;
        },
      },
    },
    {
      name: "job_location",
      label: "Job Location",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Job Location
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          // Get the row index and access the original data directly
          const rowIndex = tableMeta.rowIndex;
          const rowData = articalData[rowIndex];

          if (!rowData) {
            return <div>Loading...</div>;
          }

          const startLocation = rowData.StartLocation;
          const endLocation = rowData.EndLocation;

          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2px",
              }}
            >
              <div style={{ fontWeight: 500, color: "#333" }}>From: {startLocation || "N/A"}</div>
              <div style={{ fontWeight: 500, color: "#333" }}>To: {endLocation || "N/A"}</div>
            </div>
          );
        },
      },
    },
    {
      name: "user_id",
      label: "User ID",
      options: {
        display: false,
      },
    },
    {
      name: "image",
      label: "Image",
      options: {
        display: false,
      },
    },
    {
      name: "StartLocation",
      label: "Start Location",
      options: {
        display: false,
      },
    },
    {
      name: "EndLocation",
      label: "End Location",
      options: {
        display: false,
      },
    },
    {
      name: "brand",
      label: "Vehicle",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Vehicle
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => {
          // Get the row index and access the original data directly
          const rowIndex = tableMeta.rowIndex;
          const rowData = articalData[rowIndex];

          if (!rowData) {
            return <div>Loading...</div>;
          }

          const brand = rowData.brand;
          const wheels = rowData.wheels;
          const model = rowData.model;

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div>{`${brand || ""} / ${wheels || ""} wheeler / ${model || ""}`}</div>
            </div>
          );
        },
      },
    },
    {
      name: "wheels",
      label: "Wheels",
      options: {
        display: false,
      },
    },
    {
      name: "model",
      label: "Model",
      options: {
        display: false,
      },
    },
    {
      name: "created_at",
      label: "Created At",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Created At
            </th>
          );
        },
        customBodyRender: (value, index) => {
          const formattedDate = formatDate(value);
          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {formattedDate}
            </div>
          );
        },
      },
    },
    {
      name: "salary",
      label: "Salary",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Salary
            </th>
          );
        },
        customBodyRender: (value, index) => {
          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || ""}
            </div>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Status
            </th>
          );
        },
        customBodyRender: (value, index) => {
          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {leaveStatus(value)}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "70px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Actions
            </th>
          );
        },
        customBodyRender: (value) => (
          <div
            key={value}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              paddingLeft: "20px",
            }}
          >
            <Stack
              spacing={2}
              direction="row"
              sx={{
                justifyContent: "flex-end",
                "& .MuiButton-root": {
                  margin: "0 4px",
                },
              }}
            >
              <Button variant="outlined" onClick={() => handleViewMore(value)}>
                <RemoveRedEyeIcon /> View
              </Button>
            </Stack>
          </div>
        ),
      },
    },
  ];
  async function handleRemark() {
    handleUpdateDetails();
  }
  // Update Values Start
  const handleCloseRemark = () => {
    setOpenRemark(false);
    setStatusType([]);
    setDescriptionRemark("");
  };
  const rowsPerPageOptions = [5, 10, 25, 100];

  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    page: 0, // Always show page 0 since we're fetching correct page data from server
    count: rowCountValue,
    serverSide: false, // Client-side pagination (but we handle it via API)
    jumpToPage: false,
    fixedHeader: true,
    responsive: 'standard',
    textLabels: {
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: "Rows per page:",
        displayRows: "of",
      },
      body: {
        noMatch: "Sorry no matching records found",
      },
    },
    customFooter: (
      rowCount,
      page,
      rowsPerPage,
      changeRowsPerPage,
      changePage
    ) => {
      const totalPages = Math.ceil(rowCountValue / rowsPerPage);

      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div>
            <span>
              Showing {(pageValue - 1) * rowsPerPage + 1} -{" "}
              {Math.min(rowCountValue, pageValue * rowsPerPage)} of{" "}
              {rowCountValue} entries
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div>
              <label htmlFor="rowsPerPage">Rows per page: </label>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => {
                  const newLimit = Number(e.target.value);
                  setRowsPerPage(newLimit);
                  setPageValue(1);
                  updateUrlWithPagination(1, newLimit); // Update URL
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ padding: "10px", textAlign: "right" }}>
              Page {pageValue} of {totalPages}
              <Button
                variant="outlined"
                onClick={() => {
                  const newPage = pageValue - 1;
                  console.log("⬅️ Previous clicked. Current page:", pageValue, "New page:", newPage);
                  if (newPage >= 1) {
                    setPageValue(newPage);
                    updateUrlWithPagination(newPage, rowsPerPage);
                  }
                }}
                disabled={pageValue === 1}
                sx={{
                  margin: "0 5px",
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Previous
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  const newPage = pageValue + 1;
                  console.log("➡️ Next clicked. Current page:", pageValue, "New page:", newPage);
                  if (newPage <= totalPages) {
                    setPageValue(newPage);
                    updateUrlWithPagination(newPage, rowsPerPage);
                  }
                }}
                disabled={pageValue === totalPages}
                sx={{
                  margin: "0 5px",
                  color: "#1d82f5",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                    border: "1px solid black",
                  },
                }}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      );
    },
    tableBody: {
      style: {
        maxHeight: `${rowsPerPage * 50}px`,
        overflow: "auto",
        marginLeft: "5px",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        boxShadow: "none",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {},
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <HeaderVacanciesCreated onFiltersChange={handleFiltersChange} />

      {/* Add Jobs Button - Hidden */}
      {/* <Box sx={{ padding: "16px 0", display: "flex", justifyContent: "flex-start" }}>
        <Button
          variant="contained"
          onClick={handleOpenAddJob}
          sx={{
            backgroundColor: "#1d82f5",
            "&:hover": { backgroundColor: "#1565c0" },
            textTransform: "none",
            padding: "10px 24px",
            fontSize: "15px",
            fontWeight: 600,
          }}
        >
          + Add Jobs
        </Button>
      </Box> */}
      <Dialog
        fullWidth
        maxWidth="md"
        open={openRemark}
        onClose={handleCloseRemark}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#141b2d",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseRemark}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              Add Remark
            </Typography>
          </Toolbar>
        </AppBar>

        <Box sx={{ background: "#fff" }}>
          <Grid
            container
            spacing={4}
            style={{ color: "black", padding: "20px" }}
          >
            <Grid item xs={11} sm={4} md={3}>
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Status
                </Typography>
                <Select
                  value={statusType}
                  autoFocus
                  onChange={(e) => setStatusType(parseInt(e.target.value, 10))}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    border: "1px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": {
                        borderColor: "black !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black !important",
                      },
                    },
                    color: "black",
                  }}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return (
                        <span style={{ color: "gray" }}>
                          Select Status Type
                        </span>
                      );
                    }
                    if (selected === 0) {
                      return "Rejected";
                    }
                    if (selected === 2) {
                      return "Approved";
                    }
                    return "Unknown";
                    // return selected === 0 ? "Rejected" : "Approved";
                  }}
                >
                  <MenuItem value={0}>Rejected</MenuItem>
                  <MenuItem value={2}>Approved</MenuItem>
                </Select>
              </Stack>
            </Grid>
            <Grid item xs={11} sm={7.5} md={8.5}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Remark<span style={{ color: "red" }}>*</span>
                </Typography>

                <ReactQuill
                  value={descriptionRemark}
                  onChange={setDescriptionRemark}
                  modules={modules}
                  theme="snow"
                  style={{
                    width: "100%",
                    height: "70px",
                    boxSizing: "border-box",
                    color: "black",
                    borderBlockColor: "black",
                  }}
                />
              </Stack>
            </Grid>
          </Grid>

          <Grid container sx={{ padding: "50px 0 30px 20px" }}>
            <Grid item xs={11} className="messageFooter">
              <Box className="response" onClick={SaveRemark}>
                Save
              </Box>
              <Box className="cancel" onClick={handleCloseRemark}>
                Cancel
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>

      {/* Add Jobs Modal */}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openAddJob}
        onClose={handleCloseAddJob}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#fff",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseAddJob}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              Add New Job
            </Typography>
          </Toolbar>
        </AppBar>

        <Box sx={{ background: "#fff", padding: "24px" }}>
          <Grid container spacing={3}>
            {/* Client Checkbox and Dropdown */}
            <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                <Checkbox
                  checked={addJobData.disable_client}
                  onChange={(e) => {
                    handleAddJobChange("disable_client", e.target.checked);
                    // Reset vehicle selection when toggling client disable
                    handleAddJobChange("client_id", "");
                    handleAddJobChange("vehicle_id", "");

                    // When client selection is disabled, fetch vehicles using default client ID
                    if (e.target.checked) {
                      fetchVehicles("RPTPLOWN1726939809");
                    } else {
                      // When client selection is re-enabled, clear vehicles
                      setVehicles([]);
                    }
                  }}
                  sx={{ color: "#1d82f5", "&.Mui-checked": { color: "#1d82f5" } }}
                />
                <Typography variant="body1" sx={{ ml: 1, color: "#000" }}>
                  Disable Client Selection
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="column">
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: "#000" }}>
                  Client {!addJobData.disable_client && <span style={{ color: "red" }}>*</span>}
                </Typography>
                <Autocomplete
                  disabled={addJobData.disable_client}
                  options={clients}
                  getOptionLabel={(option) => `${option.username} (${option.id})`}
                  value={clients.find((c) => c.id === addJobData.client_id) || null}
                  filterOptions={(options, state) => {
                    const inputValue = state.inputValue.toLowerCase();
                    return options.filter((option) =>
                      option.username.toLowerCase().includes(inputValue) ||
                      option.id.toLowerCase().includes(inputValue)
                    );
                  }}
                  onChange={(event, newValue) => {
                    handleAddJobChange("client_id", newValue ? newValue.id : "");
                    // Clear vehicle selection and fetch vehicles for the selected client
                    handleAddJobChange("vehicle_id", "");
                    if (newValue?.id) {
                      fetchVehicles(newValue.id);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search client by name or ID..."
                      variant="outlined"
                      size="small"
                      sx={{
                        bgcolor: "#f5f5f5",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover fieldset": {
                            borderColor: "#1d82f5",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#1d82f5",
                          },
                        },
                        "& .MuiAutocomplete-inputRoot": {
                          color: "#000",
                        },
                      }}
                    />
                  )}
                />
              </Stack>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="column">
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: "#000" }}>
                  Vehicle <span style={{ color: "red" }}>*</span>
                </Typography>
                <Autocomplete
                  disabled={!addJobData.disable_client && !addJobData.client_id}
                  options={vehicles}
                  getOptionLabel={(option) => {
                    if (!option) return "";
                    return option.name || `${option.vehicle_id || option.id} / ${option.brand} / ${option.wheels} wheeler / ${option.model}`;
                  }}
                  value={vehicles.find((v) => v.id === addJobData.vehicle_id) || null}
                  filterOptions={(options, state) => {
                    const inputValue = state.inputValue.toLowerCase();
                    return options.filter((option) => {
                      const vehicleId = (option.vehicle_id || option.id || "").toLowerCase();
                      const brand = (option.brand || "").toLowerCase();
                      const wheels = (option.wheels || "").toLowerCase();
                      return (
                        vehicleId.includes(inputValue) ||
                        brand.includes(inputValue) ||
                        wheels.includes(inputValue)
                      );
                    });
                  }}
                  noOptionsText={vehicles.length === 0 ? "No vehicles available. Please select a client or check connection." : "No matching vehicles found"}
                  onChange={(event, newValue) => {
                    handleAddJobChange("vehicle_id", newValue ? newValue.id : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search vehicle by ID, brand, or wheels..."
                      variant="outlined"
                      size="small"
                      sx={{
                        bgcolor: "#f5f5f5",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover fieldset": {
                            borderColor: "#1d82f5",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#1d82f5",
                          },
                        },
                        "& .MuiAutocomplete-inputRoot": {
                          color: "#000",
                        },
                      }}
                    />
                  )}
                />
              </Stack>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="column">
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: "#000" }}>
                  Start Location <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  value={addJobData.start_location}
                  onChange={(e) => handleAddJobChange("start_location", e.target.value)}
                  placeholder="Enter start location"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{
                    bgcolor: "#f5f5f5",
                    color: "#000",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover fieldset": {
                        borderColor: "#1d82f5",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#1d82f5",
                      },
                    },
                    "& .MuiInputBase-input": {
                      color: "#000",
                    },
                  }}
                />
                {addJobData.start_location && (
                  <Typography
                    variant="caption"
                    sx={{
                      mt: 1,
                      color: addJobData.lat && addJobData.lng ? "#2e7d32" : "#666",
                      fontSize: "11px"
                    }}
                  >
                    {addJobData.lat && addJobData.lng
                      ? `📍 Coordinates: ${addJobData.lat}, ${addJobData.lng}`
                      : "🔄 Geocoding..."}
                  </Typography>
                )}
              </Stack>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="column">
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: "#000" }}>
                  End Location <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  value={addJobData.end_location}
                  onChange={(e) => handleAddJobChange("end_location", e.target.value)}
                  placeholder="Enter end location"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{
                    bgcolor: "#f5f5f5",
                    color: "#000",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover fieldset": {
                        borderColor: "#1d82f5",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#1d82f5",
                      },
                    },
                    "& .MuiInputBase-input": {
                      color: "#000",
                    },
                  }}
                />
              </Stack>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="column">
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: "#000" }}>
                  Salary <span style={{ color: "red" }}>*</span>
                </Typography>
                <Autocomplete
                  freeSolo
                  options={salaryOptions}
                  value={addJobData.salary || null}
                  onChange={(event, newValue) => {
                    handleAddJobChange("salary", newValue || "");
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (event) {
                      handleAddJobChange("salary", newInputValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search or enter salary"
                      variant="outlined"
                      size="small"
                      sx={{
                        bgcolor: "#f5f5f5",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover fieldset": {
                            borderColor: "#1d82f5",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#1d82f5",
                          },
                        },
                        "& .MuiAutocomplete-inputRoot": {
                          color: "#000",
                        },
                      }}
                    />
                  )}
                />
              </Stack>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack direction="column">
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: "#000" }}>
                  Job Nature <span style={{ color: "red" }}>*</span>
                </Typography>
                <Autocomplete
                  freeSolo
                  options={jobNatureOptions}
                  value={addJobData.nature || null}
                  onChange={(event, newValue) => {
                    handleAddJobChange("nature", newValue || "");
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (event) {
                      handleAddJobChange("nature", newInputValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Enter or select job nature"
                      variant="outlined"
                      size="small"
                      sx={{
                        bgcolor: "#f5f5f5",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover fieldset": {
                            borderColor: "#1d82f5",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#1d82f5",
                          },
                        },
                        "& .MuiAutocomplete-inputRoot": {
                          color: "#000",
                        },
                      }}
                    />
                  )}
                />
              </Stack>
            </Grid>
          </Grid>

          <Grid container sx={{ padding: "30px 0 0 0", justifyContent: "flex-end", gap: "10px" }}>
            <Button
              variant="outlined"
              onClick={handleCloseAddJob}
              sx={{
                borderColor: "#1d82f5",
                color: "#1d82f5",
                "&:hover": {
                  borderColor: "#1565c0",
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSaveJob}
              sx={{
                backgroundColor: "#1d82f5",
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              Save Job
            </Button>
          </Grid>
        </Box>
      </Dialog>

      <Divider />
      <ListItemText style={{ background: "white", margin: 0 }}>
        <ThemeProvider theme={getTheme()}>
          <Box
            sx={{
              maxWidth: "100%",
            }}
          >
            <MUIDataTable
              key={`table-${tableKey}-${pageValue}-${rowsPerPage}`}
              title="Vacancies Created"
              data={articalData}
              columns={columns}
              options={options}
            />
          </Box>
        </ThemeProvider>
      </ListItemText>
    </>
  );
}

export default VacanciesCreated;
